'use strict';
const stickyHeader = {

	header: document.querySelector('.js-site-header'),

	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		let prevPosY = window.scrollY;

		if (window.scrollY > 10) {
			this.header.classList.add('sticky');
		}

		window.addEventListener('scroll', () => {
			const posY = window.scrollY;

			if (posY < 10) {
				this.header.classList.remove('sticky');
			} else {
				this.header.classList.add('sticky');
			}

			if (posY <= prevPosY || prevPosY <= 0) {
				this.header.classList.remove('hide-on-scroll');
			} else {
				this.header.classList.add('hide-on-scroll');
			}

			prevPosY = posY;
		});
	},

};

export default stickyHeader;
